import { For, Show } from "solid-js";
import type { SkillSummary } from "~/lib/api";

type Props = {
  skills?: SkillSummary[] | null;
  limit?: number;
};

export function SkillChips(props: Props) {
  const items = () => {
    const skills = props.skills ?? [];
    return props.limit ? skills.slice(0, props.limit) : skills;
  };

  return (
    <Show when={items().length}>
      <div class="skill-chip-row">
        <For each={items()}>{(tag) => <span class="skill-chip">{tag.label}</span>}</For>
      </div>
    </Show>
  );
}
